import { MessageBar, MessageBarType } from '@fluentui/react';
import React, { useMemo } from 'react';
import { useNotifications, useNotificationsManager } from '../../../contexts/notificationContext';
import Countdown from './Countdown';

const MainMessageBar = () => {

    const { dismiss } = useNotificationsManager();
    const { notifications } = useNotifications();

    const styles = {
        content: { alignItems: "center" }
    };

    const messages = useMemo(() => {
        if (Array.isArray(notifications)) {
            const messages = notifications.filter(notification => notification.type !== MessageBarType.info);
            return messages;
        }
        else return [];
    }, [notifications]);

    if (messages.length > 0)
        return messages.map(notification => {
            const { id, message, type } = notification;
            return <MessageBar
                actions={<Countdown onZero={() => dismiss(id)} />}
                dismissButtonAriaLabel="Fermer"
                isMultiline={false}
                id={`${MessageBarType[type]}MsgBar-${id}`}
                key={id}
                messageBarType={type}
                onDismiss={() => dismiss(id)}
                styles={styles}
            >
                {message}
            </MessageBar>
        });
    else return null;

};

export default MainMessageBar;